import get from 'lodash.get';
import { transformPlanDetails } from '../../S/pricing/pricing.transformer';
import { IPartnerPlanData } from '../types';

export const transformPartnerPlanData = (
  partnerPlanData: Array<Partial<IPartnerPlanData>>
): Array<IPartnerPlanData> => {
  if (!Array.isArray(partnerPlanData)) return [];
  return partnerPlanData.map((plan) => ({
    planDetails: transformPlanDetails(plan.planDetails),
    coupon: get(plan, 'coupon', null),
    partnerSlug: get(plan, 'partnerSlug', ''),
  }));
};
